import { render, staticRenderFns } from "./floor6.vue?vue&type=template&id=2c0e8d28&scoped=true"
import script from "./floor6.vue?vue&type=script&lang=js"
export * from "./floor6.vue?vue&type=script&lang=js"
import style0 from "./floor6.vue?vue&type=style&index=0&id=2c0e8d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0e8d28",
  null
  
)

/* custom blocks */
import block0 from "./floor6.vue?vue&type=custom&index=0&blockType=div&v-if=index%20%3D%3D%20currentIndex&class=blueline&%3Aclass=%7B%20active%3A%20isAnimating%20%7D"
if (typeof block0 === 'function') block0(component)

export default component.exports